import MedicationsTab from "./MedicationsTab";

export default MedicationsTab;